export function getFileExtension(url) {
  // 利用 URL API 解析
  const pathname = new URL(url, window.location.href).pathname;
  const lastPart = pathname.split('/').pop()!; // 取最后一段文件名
  const dotIndex = lastPart.lastIndexOf('.');
  if (dotIndex === -1) return ''; // 没有后缀
  return lastPart.slice(dotIndex + 1).toLowerCase();
}
export function addQuery(url, newParams) {
  const u = new URL(url, window.location.href);

  // 提取原有的 search 和 hash
  const oldQuery = u.search; // 包含 '?'
  const hash = u.hash;

  // 清掉原有 query 和 hash
  u.search = '';
  u.hash = '';

  let finalUrl = u.toString();

  if (newParams) {
    // 去掉开头的 "?" 防止重复
    const cleanParams = newParams.replace(/^\?+/, '');
    finalUrl += '?' + cleanParams;
  }

  if (oldQuery) {
    finalUrl += (finalUrl.includes('?') ? '&' : '?') + oldQuery.slice(1);
  }

  if (hash) {
    finalUrl += hash;
  }

  return finalUrl;
}
